import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/user-default.svg'
import _imports_1 from '@/assets/icons/camera.svg'
import _imports_2 from '@/assets/icons/send.svg'


const _hoisted_1 = { class: "ticket-messages" }
const _hoisted_2 = { class: "message-loader" }
const _hoisted_3 = {
  key: 0,
  class: "uploaded-images"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "pictures" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "empty-info"
}
const _hoisted_8 = { class: "message-interactions" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "avatar",
  class: "avatar"
}, null, -1)
const _hoisted_10 = { class: "reply-wrap" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "textarea-wrapper" }
const _hoisted_13 = { class: "pictures" }
const _hoisted_14 = ["id"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  id: "picture-output",
  class: "picture-output"
}, null, -1)
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "submit"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clip_loader = _resolveComponent("clip-loader")!
  const _component_ClickablePicture = _resolveComponent("ClickablePicture")!
  const _component_MessageRow = _resolveComponent("MessageRow")!
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!
  const _component_CloseBtn = _resolveComponent("CloseBtn")!
  const _component_CustomCard = _resolveComponent("CustomCard")!

  return (_openBlock(), _createBlock(_component_CustomCard, {
    optClass: "t-messages",
    id: "messages"
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("TICKET_DETAIL.ADD_QUESTION")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["messages", { loading: _ctx.sendMessageLoading }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.sendMessageLoading)
              ? (_openBlock(), _createBlock(_component_clip_loader, {
                  key: 0,
                  color: "#777777",
                  size: "50px"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.data.uploadedFilesUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("TICKET_DETAIL.MESSAGES.UPLOADED_IMAGES")), 1),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.uploadedFilesUrl, (picture) => {
                        return (_openBlock(), _createBlock(_component_ClickablePicture, {
                          key: picture,
                          imageUrl: picture.url
                        }, null, 8, ["imageUrl"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.data.messages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.messages, (message) => {
                  return (_openBlock(), _createElementBlock("div", { key: message }, [
                    _createVNode(_component_MessageRow, { message: message }, null, 8, ["message"])
                  ]))
                }), 128))
              ]))
            : (!_ctx.data.uploadedFilesUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.t("TICKET_DETAIL.NO_QUESTIONS")), 1))
              : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              src: _imports_1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOnUpload && _ctx.clickOnUpload(...args))),
              title: _ctx.t('NEW_TICKET.ADD_PICTURE'),
              class: _normalizeClass(["attach-photo", { disabled: _ctx.messagePictures.length >= 3 }])
            }, null, 10, _hoisted_11),
            _createElementVNode("input", {
              id: "image-input",
              type: "file",
              accept: "image/*",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadImage && _ctx.loadImage(...args))),
              style: {"display":"none"}
            }, null, 32),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_CustomTextArea, {
                insideText: _ctx.newMessage,
                "onUpdate:insideText": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newMessage) = $event)),
                placeholderText: _ctx.t('TICKET_DETAIL.MESSAGES.PLACEHOLDER'),
                invalid: _ctx.isMessageInvalid,
                onSetValid: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMessageInvalid.invalid = false))
              }, null, 8, ["insideText", "placeholderText", "invalid"]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messagePictures, (messagePic, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: messagePic,
                    id: 'picture-' + index,
                    class: "picture"
                  }, [
                    _hoisted_15,
                    _createVNode(_component_CloseBtn, { onClick: _ctx.deleteLoadedImage }, null, 8, ["onClick"])
                  ], 8, _hoisted_14))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendMessage())),
            title: _ctx.t('TICKET_DETAIL.MESSAGES.SEND'),
            class: "send-btn",
            type: "submit",
            "data-cy": "send-message-btn"
          }, _hoisted_18, 8, _hoisted_16)
        ])
      ])
    ]),
    _: 1
  }))
}